import React from "react";
import styled from "styled-components";
import { Card as ShadCard, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Send, Mail } from "lucide-react";

const Container = styled.div`
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #ccc;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
`;

const Card = styled(ShadCard)`
  width: 320px;
  border-bottom: 5px solid rgb(0, 176, 0);
  cursor: pointer;
`;

const DemoProjects = () => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <Container>
      <Dialog open={showModal} onOpenChange={() => setShowModal(false)}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle>Project Details</DialogTitle>
          </DialogHeader>
          <div>
            <strong>Company:</strong> Power Recruitment
            <br />
            <strong>Industry:</strong> Mining &amp; Technical
            <br />
            <strong>Description:</strong>
            <br />
            <p>
              Power Recruitment is leading a pioneering initiative to collaborate
              with various recruitment agencies in addressing the escalating
              talent needs of the Mining and Technical industry. This strategic
              partnership endeavor is designed to harness the unique strengths of
              each agency, creating a synergistic network aimed at filling diverse
              roles within the sector. Emphasizing diversity and inclusion, the
              project seeks to leverage the collective expertise of partner
              agencies to actively engage with underrepresented talent pools and
              promote a more inclusive workforce.
            </p>
            <strong>Roles:</strong> Mining Supervisor, Project Managers, Process
            Engineers, Electrical Engineers
            <br />
            <strong>Start date:</strong> 1 March 2024
            <br />
            <strong>End date:</strong> 30 April 2024
            <br />
            <strong>Support agency expectations:</strong>
            <br />
            Sourcing candidated, screening candidates, payrolling candidates,
            managing timesheets
            <hr />
            <div className="space-y-2 mb-3">
              <Label htmlFor="formFamilyName">Name*</Label>
              <Input id="formFamilyName" type="text" required />
            </div>
            <div className="space-y-2 mb-3">
              <Label htmlFor="formCompany">Company*</Label>
              <Input id="formCompany" type="text" required />
            </div>
            <div className="space-y-2 mb-3">
              <Label htmlFor="formEmail">Email*</Label>
              <Input id="formEmail" type="text" required />
            </div>
            <div className="space-y-2 mb-3">
              <Label htmlFor="formPhone">Phone*</Label>
              <Input id="formPhone" type="text" required />
            </div>
          </div>
          <DialogFooter>
            <Button variant="default">
              <Mail className="h-4 w-4" /> Agent Query
            </Button>
            <Button variant="default">
              <Send className="h-4 w-4" /> Express Interest
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <h5>Projects</h5>
      <CardContainer>
        <Card onClick={() => setShowModal(true)}>
          <CardContent>
            <div>
              <div>
                <strong>Company:</strong> Power Recruitment
              </div>
              <div>
                <strong>Industry:</strong> Mining &amp; Technical
              </div>
              <div>
                <strong>Description:</strong>
              </div>
              <div>
                Power Recruitment is an MSP seeking to partner with agencies
                specialising in engaging diverse talent ...
              </div>
            </div>
          </CardContent>
        </Card>
        <Card onClick={() => setShowModal(true)}>
          <CardContent>
            <div>
              <div>
                <strong>Company:</strong> Lloyd Recruitment
              </div>
              <div>
                <strong>Industry:</strong> Education
              </div>
              <div>
                <strong>Description:</strong>
              </div>
              <div>
                Lloyd Recruitment is looking for agencies to support recruitment
                of ELT specialists into ...
              </div>
            </div>
          </CardContent>
        </Card>
      </CardContainer>
    </Container>
  );
};

export default DemoProjects;
